import type {IconName} from '@sollapay/ui/components';

export interface NavItemConfig {
  id: string;
  labelKey: string;
  icon: IconName;
  path: string;
  disabled?: boolean;
}

export interface NavGroupRawConfig {
  id: string;
  labelKey: string;
  items: NavItemConfig[];
}

export const navGroups: NavGroupRawConfig[] = [
  {
    id: 'main',
    labelKey: 'main',
    items: [{id: 'accounts', labelKey: 'accounts', icon: 'shield', path: '/trust-accounts'}]
  },
  {
    id: 'orgSettings',
    labelKey: 'orgSettings',
    items: [{id: 'team', labelKey: 'team', icon: 'users', path: '/team'}]
  }
];

export const guestNavGroups: NavGroupRawConfig[] = [
  {
    id: 'main',
    labelKey: 'main',
    items: [{id: 'accounts', labelKey: 'accounts', icon: 'shield', path: '/trust-accounts'}]
  }
];
